"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Created by vadimdez on 20/01/2017.
 */
var core_1 = require("@angular/core");
var ngx_order_pipe_1 = require("./ngx-order.pipe");
var OrderModule = (function () {
    function OrderModule() {
    }
    return OrderModule;
}());
OrderModule = __decorate([
    core_1.NgModule({
        declarations: [ngx_order_pipe_1.OrderPipe],
        exports: [ngx_order_pipe_1.OrderPipe]
    })
], OrderModule);
exports.OrderModule = OrderModule;
//# sourceMappingURL=ngx-order.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-order-pipe/dist/src/ngx-order.module.js
// module id = 1105
// module chunks = 3